// =============================================================================
//  KOMPONENTE: Numpad (mit Tabulator-Funktion)
// =============================================================================
import React from 'react';

const Numpad = ({ onKeyPress, onBackspace, onClear, onNext, onPrev }) => {
  // GEÄNDERT: Das Layout wird angepasst, um Platz für die neuen Tasten zu schaffen.
  const keys = [
    '1', '2', '3',
    '4', '5', '6',
    '7', '8', '9',
    '⌫', '0', 'C',
    'PREV', 'NEXT' // NEUE Tasten
  ];

  const handleButtonClick = (key) => {
    if (key === 'C') onClear();
    else if (key === '⌫') onBackspace();
    else if (key === 'NEXT') onNext();   // NEU
    else if (key === 'PREV') onPrev();   // NEU
    else onKeyPress(key);
  };

  const renderKey = (key) => {
    let content = key;
    if (key === 'PREV') content = '↑';
    if (key === 'NEXT') content = '↓';
    
    // NEU: Weist den Tasten spezielle Klassen für das Styling zu
    let className = "numpad-key";
    if (key === 'PREV' || key === 'NEXT') {
      className += " numpad-key-nav";
    }
    if (key === 'C' || key === '⌫') {
      className += " numpad-key-action";
    }

    return (
      <button
        key={key}
        type="button"
        className={className}
        onClick={() => handleButtonClick(key)}
        style={key === 'PREV' || key === 'NEXT' ? { gridColumn: 'span 1' } : {}}
      >
        {content}
      </button>
    );
  };

  return (
    // GEÄNDERT: Das Grid wird für die neuen Tasten angepasst
    <div className="numpad-container">
      {keys.slice(0, 12).map(renderKey)}
      <div className="numpad-nav-row">
        {renderKey('PREV')}
        {renderKey('NEXT')}
      </div>
    </div>
  );
};

export default Numpad;